var e = Symbol("cache-parser");
function r(e, r) {
  (null == r || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++) a[t] = e[t];
  return a;
}
function t(e) {
  return ("string" == typeof e || "number" == typeof e) && (e = Number(e)) >= 0 && e < Infinity;
}
function a(e) {
  return !0 === e || "number" == typeof e || "string" == typeof e && "false" !== e;
}
var n = Number;
function o(o) {
  var i = Object.defineProperty({}, e, {
    enumerable: !1,
    value: 1
  });
  if (!o || "string" != typeof o) return i;
  var s = function (e) {
      for (var t, a = {}, n = function (e, t) {
          var a = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (a) return (a = a.call(e)).next.bind(a);
          if (Array.isArray(e) || (a = function (e, t) {
            if (e) {
              if ("string" == typeof e) return r(e, t);
              var a = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? r(e, t) : void 0;
            }
          }(e))) {
            a && (e = a);
            var n = 0;
            return function () {
              return n >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[n++]
              };
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }(e.toLowerCase().replace(/\s+/g, "").split(",")); !(t = n()).done;) {
        var o,
          i = t.value.split("=", 2);
        a[i[0]] = null == (o = i[1]) || o;
      }
      return a;
    }(o),
    l = s["max-age"],
    u = s["max-stale"],
    m = s["min-fresh"],
    p = s["s-maxage"],
    f = s["stale-if-error"],
    c = s["stale-while-revalidate"];
  return a(s.immutable) && (i.immutable = !0), t(l) && (i.maxAge = n(l)), t(u) && (i.maxStale = n(u)), t(m) && (i.minFresh = n(m)), a(s["must-revalidate"]) && (i.mustRevalidate = !0), a(s["must-understand"]) && (i.mustUnderstand = !0), a(s["no-cache"]) && (i.noCache = !0), a(s["no-store"]) && (i.noStore = !0), a(s["no-transform"]) && (i.noTransform = !0), a(s["only-if-cached"]) && (i.onlyIfCached = !0), a(s.private) && (i.private = !0), a(s["proxy-revalidate"]) && (i.proxyRevalidate = !0), a(s.public) && (i.public = !0), t(p) && (i.sMaxAge = n(p)), t(f) && (i.staleIfError = n(f)), t(c) && (i.staleWhileRevalidate = n(c)), i;
}
function i(e) {
  if (!e || "object" != typeof e) return [];
  var r = [];
  return a(e.immutable) && r.push("immutable"), t(e.maxAge) && r.push("max-age=" + e.maxAge), t(e.maxStale) && r.push("max-stale=" + e.maxStale), t(e.minFresh) && r.push("min-fresh=" + e.minFresh), a(e.mustRevalidate) && r.push("must-revalidate"), a(e.mustUnderstand) && r.push("must-understand"), a(e.noCache) && r.push("no-cache"), a(e.noStore) && r.push("no-store"), a(e.noTransform) && r.push("no-transform"), a(e.onlyIfCached) && r.push("only-if-cached"), a(e.private) && r.push("private"), a(e.proxyRevalidate) && r.push("proxy-revalidate"), a(e.public) && r.push("public"), t(e.sMaxAge) && r.push("s-maxage=" + e.sMaxAge), t(e.staleIfError) && r.push("stale-if-error=" + e.staleIfError), t(e.staleWhileRevalidate) && r.push("stale-while-revalidate=" + e.staleWhileRevalidate), r;
}
function s(r) {
  return !!r && !!r[e];
}
export { s as isCacheControl, o as parse, i as tokenize };
